// extracted by mini-css-extract-plugin
export var fadeIn = "_dt-1";
export var modalContent = "_dt-3";
export var overlay = "_dt-0";
export var popoverContent = "_dt-2";
export var results = "_dt-5";
export var searchInputWrapper = "_dt-4";